module.exports = "/_next/static/images/14f1039710a603b9ccaad25bc4726bec-pen@desktop1366.jpg.webp";